module.exports = __webpack_public_path__ + "static/media/1615341013319.0158ca0f.jpg";